import { Form, InputNumber } from "formik-antd";
import { useTranslation } from "react-i18next";
import { IconToolTip } from "/app/src/components/icons/IconBuilder";

/**
 * Form for creating and updating the request retries setting
 * @param integration Integration
 */
export default function Retries() {
  const { t } = useTranslation();

  return (
    <Form.Item
      name="retries"
      label={
        <>
          {t("translation:retries")}
          <IconToolTip
            content={t("translation:retries_tip")}
            className="ml-1"
          />
        </>
      }
      hasFeedback={false}
    >
      <InputNumber
        name="retries"
        min={0}
        max={5}
        size="large"
        style={{ width: "100%" }}
        placeholder="1"
      />
    </Form.Item>
  );
}
